const vendor = [
    {
        id : 'VDP0001',
        vendor_name : 'PT Sejahtera',
        pic_name : 'Mr. Adam',
        contact : '0800023000',
        email : 'email@example.com',
        address : 'Jl. jalan, no 00',
        status : 'non-Active',
        
    },
    {
        id : 'VDP0002',
        vendor_name : 'PT Anggun',
        pic_name : 'Mr. Smith',
        contact : '0899943994',
        email : 'email@example.com',
        address : 'Jl. jalan, no 01',
        status : 'Active',
        
    },
    {
        id : 'VDP0003',
        vendor_name : 'PT Bangunjaya',
        pic_name : 'Ms. Eve',
        contact : '0800023000',
        email : 'email@example.com',
        address : 'Jl. jalan, no 03',
        status : 'Active',
        
    },
    {
        id : 'VDP0004',
        vendor_name : 'PT Berkembang',
        pic_name : 'Ms. Evelyn',
        contact : '0800023000',
        email : 'email@example.com',
        address : 'Jl. jalan, no 04',
        status : 'Active',
        
    },
    {
        id : 'VDP005',
        vendor_name : 'PT Berdikari',
        pic_name : 'Mr. Alex',
        contact : '0800023000',
        email : 'email@example.com',
        address : 'Jl. jalan, no 0',
        status : 'Active',
        
    },
    
]

export default vendor